var BoneSide;
(function (BoneSide) {
    BoneSide[BoneSide["Right"] = 0] = "Right";
    BoneSide[BoneSide["Left"] = 1] = "Left";
})(BoneSide || (BoneSide = {}));

export { BoneSide };
//# sourceMappingURL=bone-side.js.map
